import { z } from 'zod';
export const storeIdentityGrant = z.object({
    id: z.number(),
    name: z.string().min(5, 'Name must be at least 5 characters'),
    clientId: z.string(),
    createdOn: z.string(),
    updatedOn: z.string().optional(),
});
export const storeIdentityGrantCreate = storeIdentityGrant.pick({
    name: true,
});
export const storeIdentityGrantWithClientSecret = storeIdentityGrant.extend({
    clientSecret: z.string(),
});
//# sourceMappingURL=identityGrant.js.map